<script>
  import { _ } from "svelte-i18n";
  import { Route, router, meta } from "tinro";
  import { BASE_URL } from "../utilities/config.js";
  import { createEventDispatcher, onMount } from "svelte";
  import { postJsonFile } from "../utilities/Utils.svelte";
  import RangeSlider from "svelte-range-slider-pips";
  import { postJsonFileNoResponse } from "../utilities/Utils.svelte";
  import {
    currentPage,
    skillId,
    cid,
    userId,
    userName,
    assessmentType,
    assessmentId,
    instanceId,
    assessmentState,
    assessmentDefinitionId,
    activationCode,
    invitationNumber,
  } from "../utilities/DataStore.js";
  import { api } from "../utilities/Utils.svelte";

  import Loader from "./components/report/Loader.svelte";
  import { formatDateToLocale } from "../utilities/FormatUtils.svelte";
  import RadarChart from "./components/report/RadarChart.svelte";
  import { dynamicSort } from "../utilities/SortingUtils.svelte";
  import ResultReportIeltsOverall from "./components/ResultReportIeltsOverall.svelte";
  import AssessmentResults from "./AssessmentResults.svelte";
  import { isIeltsInvitation } from "./ieltsOverall.mjs";

  let errorMsg = undefined;
  let loadingState = "NEW";
  let certificationScore = undefined;
  let certificationType = undefined;

  onMount(async () => {
    if ($invitationNumber) {
      loadDataFromInvitation();
    } else {
      loadData();
    }

    initialize();
  });

  

  let assessmentList = [];

  let allFinished = false;

  function loadData() {
    loadingState = "LOADING";

    return api
      .get(`public/assessment/definition`)
      .json()
      .then((data) => {
        assessmentList = data
          .filter((a) => a.activationCode === $activationCode)
          .filter((a) => a.status === "ACTIVE" || a.status === "DRAFT");
        console.log("exerciseListData", assessmentList);
        loadingState = "OK";
      })
      .catch((error) => {
        console.log("catch error", error);
        errorMsg = "ERROR_LOADING_ASSESSMENT";
        assessmentList = [];
        loadingState = "ERROR";
      });
  }

  function loadDataFromInvitation() {
    loadingState = "LOADING";
    return api
      .get(
        `public/assessment/invitation/${$invitationNumber}/definitions-detail`,
      )
      .json()
      .then((data) => {
        assessmentList = data.map((e) => {
          return {
            id: e.idDefinition,
            code: e.code,
            name: e.name,
            description: e.description,
            idInstance: e.idInstance,
            totalDurationLimit: e.totalDurationLimit,
            status: e.status,
            invDefStatus: e.invDefStatus,
          };
        });

        let count = 0;
        let countDone = 0;
        assessmentList.forEach((e) => {
          count++;
          if (e.status === "SCORED" || e.invDefStatus === "CANCEL" || e.invDefStatus === "EXPIRED") {
            countDone++;
          }
        });
        allFinished = count === countDone;

        console.log("exerciseListData", assessmentList);
        loadingState = "OK";
      })
      .catch((error) => {
        console.log("catch error", error);
        errorMsg = "ERROR_LOADING_ASSESSMENT";
        assessmentList = [];
        loadingState = "ERROR";
      });
  }

  export let invitationId;

  let loadStatus = "LOADING";

  let exerciseListStatus = "NEW";
  let exerciseListData;
  let progressListData;
  let instanceData;

  let combinedData = undefined;

  let currentExerciseId = undefined;

  let invitationDetail = {};
  let invitationDetailStatus = "LOADING";

  let assessmentDefinitionDetail = [];
  let assessmentDefinitionDetailStatus = "LOADING";


  function generateRandomInvitationNumber(length) {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";

    for (let i = 0; i < length; i++) {
      // Pick a random index from the characters string
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }

    return result;
  }

  function initialize() {
    loadStatus = "LOADING";

    if (invitationId === "new") {
      invitationDetail = {
        assessmentType: "TOEIC",
        invitationNumber: generateRandomInvitationNumber(10),
        clientId: "",
      };
      invitationDetailStatus = "NEW";
      assessmentDefinitionDetailStatus = "NEW";
    } else {
      Promise.allSettled([
        getAssessmentInvitationDetail(),
        getAssessmentDefinitions(),
      ]).then(() => {
        console.log("allLoaded");

        combinedData = exerciseListData;
        console.log("combinedData", combinedData);
        loadStatus = "OK";
      });
    }
  }

  function getAssessmentInvitationDetail() {
    return api
      .get(
        `public/assessment/invitation/${$invitationNumber}`,
      )
      .json()
      .then((data) => {
        console.log("lessons successful", data);

        invitationDetail = data;

        try {
          invitationDetail["jobFunction"] = JSON.parse(data?.data)?.jobFunction;
          invitationDetail["locationProgram"] = JSON.parse(
            data?.data,
          )?.locationProgram;
        } catch (e) {
          console.log("error parsing additional data", e);
          loadStatus = "ERROR";
        }

        invitationDetailStatus = "OK";
      })
      .catch((error) => {
        invitationDetailStatus = "ERROR";
        console.log("error Definition", error);
      });
  }

  let overallScore = 0;
  let overallScoreMax = 0;

  let readListenScore = 0;

  let chartData = {
    TOEIC_READ: undefined,
    TOEIC_SPEAK: undefined,
    TOEIC_LISTEN: undefined,
  };

  function getAssessmentDefinitions() {
    


    api
      .get(
        `public/assessment/invitation/${$invitationNumber}/definitions-detail`,
      )
      .json()

      .then((data) => {
        console.log("lessons successful", data);

        assessmentDefinitionDetail = data;
        assessmentDefinitionDetailStatus = "OK";

        assessmentDefinitionDetail = data.sort(dynamicSort("category", 1));

        assessmentDefinitionDetail.forEach((e) => {
          chartData[e.category] = e.reviewScore;
          if (e.category === "TOEIC_READ" || e.category === "TOEIC_READ_OLD") {
            if (e?.reviewScore && e.status !== "CANCEL") {
              overallScore += 5 + Math.round((e.reviewScore * 4.9) / 5) * 5;
              readListenScore += 5 + Math.round((e.reviewScore * 4.9) / 5) * 5;
            }
            overallScoreMax += 495;
          }
          if (
            e.category === "TOEIC_SPEAK" ||
            e.category === "TOEIC_SPEAK_OLD"
          ) {
            if (e?.reviewScore && e.status !== "CANCEL") {
              overallScore += e.reviewScore * 2;
            }
            overallScoreMax += 200;
          }
          if (
            e.category === "TOEIC_LISTEN" ||
            e.category === "TOEIC_LISTEN_OLD"
          ) {
            if (e?.reviewScore && e.status !== "CANCEL") {
              overallScore += 5 + Math.round((e.reviewScore * 4.9) / 5) * 5;
              readListenScore += 5 + Math.round((e.reviewScore * 4.9) / 5) * 5;
            }
            overallScoreMax += 495;
          }
        });

        console.log("overallScoreAll", overallScore, overallScoreMax);
      })
      .catch((error) => {
        assessmentDefinitionDetailStatus = "ERROR";
        loadStatus = "ERROR";
        console.log("error Definition", error);
      });
  }

  function openDefinition(id) {
    console.log("openExerciseDetail", id);
    currentExerciseId = id;
  }

  function deleteInvitation(id) {
    console.log("deleteInvitation", id);
    currentExerciseId = id;
  }

  function scoreDetails(type, reviewScore) {
    let score = reviewScore;
    let level = "";
    let band = "red";

    console.log("scoreDetails", type, reviewScore, score, level, band);

    if (type === "TOEIC_LISTEN" || type === "TOEIC_LISTEN_OLD") {
      // score = reviewScore * 5;
      let score = 5 + Math.round((reviewScore * 4.9) / 5) * 5;
      if (score >= 60 && score <= 105) {
        level = "Beginner";
        band = "red";
      } else if (score >= 110 && score <= 270) {
        level = "High Beginner";
        band = "red";
      } else if (score >= 275 && score <= 395) {
        level = "Low Intermediate";
        band = "amber";
      } else if (score >= 400 && score <= 485) {
        level = "Intermediate";
        band = "green";
      } else if (score >= 490 && score <= 495) {
        level = "High Intermediate";
        band = "green";
      }

      return {
        score: score,
        max: 495,
        normalized: reviewScore / 100,
        pct: reviewScore,
        level: level,
        band: band,
        min: 5,
        mid: 275,
        high: 400,
      };
    } else if (type === "TOEIC_READ" || type === "TOEIC_READ_OLD") {
      // score = reviewScore * 5;
      let score = 5 + Math.round((reviewScore * 4.9) / 5) * 5;
      if (score >= 60 && score <= 110) {
        level = "Beginner";
        band = "red";
      } else if (score >= 115 && score <= 270) {
        level = "High Beginner";
        band = "red";
      } else if (score >= 275 && score <= 380) {
        level = "Low Intermediate";
        band = "amber";
      } else if (score >= 385 && score <= 450) {
        level = "Intermediate";
        band = "green";
      } else if (score >= 455 && score <= 495) {
        level = "High Intermediate";
        band = "green";
      }

      console.log("readScore", reviewScore, score);

      return {
        score: score,
        max: 495,
        normalized: reviewScore / 100,
        pct: reviewScore,
        level: level,
        band: band,
        min: 5,
        mid: 275,
        high: 385,
      };
    } else if (type === "TOEIC_SPEAK" || type === "TOEIC_SPEAK_OLD") {
      let score = reviewScore * 2;
      if (score >= 50 && score <= 80) {
        level = "Beginner";
        band = "red";
      } else if (score >= 90 && score <= 110) {
        level = "High Beginner";
        band = "red";
      } else if (score >= 120 && score <= 150) {
        level = "Low Intermediate";
        band = "amber";
      } else if (score >= 160 && score <= 170) {
        level = "Intermediate";
        band = "green";
      } else if (score >= 180 && score <= 200) {
        level = "High Intermediate";
        band = "green";
      }

      return {
        score: score,
        max: 200,
        normalized: reviewScore / 100,
        pct: reviewScore,
        level: level,
        band: band,
        min: 0,
        mid: 120,
        high: 160,
      };
    } else if (type === "TOEIC_OVERALL") {
      let score = reviewScore;
      if (score >= 170 && score <= 295) {
        level = "Beginner";
        band = "red";
      } else if (score >= 300 && score <= 650) {
        level = "High Beginner";
        band = "red";
      } else if (score >= 655 && score <= 925) {
        level = "Low Intermediate";
        band = "amber";
      } else if (score >= 925 && score <= 1105) {
        level = "Intermediate";
        band = "green";
      } else if (score >= 1110 && score <= 1190) {
        level = "High Intermediate";
        band = "green";
      }

      return {
        score: score,
        max: 1190,
        normalized: reviewScore / 1190,
        pct: reviewScore / 12,
        level: level,
        band: band,
        min: 10,
        mid: 655,
        high: 925,
      };
    } else if (type === "TOEIC_READ_LISTEN") {
      let score = reviewScore;
      if (score >= 120 && score <= 215) {
        level = "Beginner";
        band = "red";
      } else if (score >= 220 && score <= 545) {
        level = "High Beginner";
        band = "red";
      } else if (score >= 550 && score <= 780) {
        level = "Low Intermediate";
        band = "amber";
      } else if (score >= 785 && score <= 940) {
        level = "Intermediate";
        band = "green";
      } else if (score >= 945 && score <= 990) {
        level = "High Intermediate";
        band = "green";
      }

      return {
        score: score,
        max: 990,
        normalized: reviewScore / 990,
        pct: reviewScore / 990.0,
        level: level,
        band: band,
        min: 10,
        mid: 550,
        high: 945,
      };
    }
  }

  let toeicLevels = {
    levels: [
      {
        level: "Beginner",
        cefr: "A1",
        listeningRange: [60, 105],
        readingRange: [60, 110],
        speakingRange: [50, 80],
        listeningDesc:
          "The respondent at this level can understand short descriptions of photographs and basic spoken exchanges with easy vocabulary but struggle with indirect language or complex grammar.",
        readingDesc:
          "The respondent can locate factual information when text matches questions directly but lack inference skills and struggle with paraphrased content.",
        speakingDesc:
          "The respondent have limited ability to express opinions or answer questions. Pronunciation and grammar are inconsistent, often leading to unclear communication.",
      },
      {
        level: "High Beginner",
        cefr: "A2",
        listeningRange: [110, 270],
        readingRange: [115, 270],
        speakingRange: [90, 110],
        listeningDesc:
          "The respondent can infer basic context in short exchanges with repetition but struggle with extended texts requiring connections between ideas.",
        readingDesc:
          "The respondent understand medium-level vocabulary and simple paraphrased facts but cannot consistently interpret idiomatic usage.",
        speakingDesc:
          "The respondent can give basic information but have difficulty supporting opinions. Responses may include hesitations and grammatical errors.",
      },
      {
        level: "Low Intermediate",
        cefr: "B1",
        listeningRange: [275, 395],
        readingRange: [275, 380],
        speakingRange: [120, 150],
        listeningDesc:
          "The respondent understand extended texts with repetition and can handle medium-level vocabulary but struggle with indirect responses.",
        readingDesc:
          "The respondent connect information within small text sections and understand some difficult vocabulary in context.",
        speakingDesc:
          "The respondent can express opinions but explanations may be unclear due to limited vocabulary or pronunciation issues.",
      },
      {
        level: "Intermediate",
        cefr: "B2",
        listeningRange: [400, 485],
        readingRange: [385, 450],
        speakingRange: [160, 170],
        listeningDesc:
          "The respondent infer central ideas in complex exchanges and understand details with paraphrased information.",
        readingDesc:
          "The respondent connect information across texts and understand idiomatic usage but may struggle with dense content.",
        speakingDesc:
          "The respondent deliver clear responses with minor grammatical errors and effective workplace vocabulary.",
      },
      {
        level: "High Intermediate",
        cefr: "C1",
        listeningRange: [490, 495],
        readingRange: [455, 495],
        speakingRange: [180, 200],
        listeningDesc:
          "The respondent handle all workplace listening tasks effortlessly, including indirect language and complex grammar.",
        readingDesc:
          "The respondent interpret dense texts, idiomatic phrases, and make nuanced distinctions between vocabulary.",
        speakingDesc:
          "The respondent produce fluent, well-structured discourse with precise vocabulary and highly intelligible pronunciation.",
      },
    ],
  };

  function generateTOEICDescription(chartData) {
    let listeningScore = chartData["TOEIC_LISTEN"] * 5;
    if (!chartData["TOEIC_LISTEN"]) {
      listeningScore = chartData["TOEIC_LISTEN_OLD"] * 5;
    }
    let readingScore = chartData["TOEIC_READ"] * 5;
    if (!chartData["TOEIC_READ"]) {
      readingScore = chartData["TOEIC_READ_OLD"] * 5;
    }
    let speakingScore = chartData["TOEIC_SPEAK"] * 2;
    if (!chartData["TOEIC_SPEAK"]) {
      speakingScore = chartData["TOEIC_SPEAK_OLD"] * 2;
    }

    const levels = toeicLevels.levels;

    // Find descriptors for each section
    const getDescriptor = (score, section) => {
      const level = levels.find(
        (l) =>
          score >= l[`${section}Range`][0] && score <= l[`${section}Range`][1],
      );
      return level
        ? level[`${section}Desc`]
        : "Feedback is unavailable due to insufficient or incomplete responses. To receive feedback, ensure all questions are fully and clearly answered when retaking the assessment.";
    };

    const listeningDesc = getDescriptor(listeningScore, "listening");
    const readingDesc = getDescriptor(readingScore, "reading");
    const speakingDesc = getDescriptor(speakingScore, "speaking");

    // Combine into one paragraph
    return `In the TOEIC Listening section, ${listeningDesc.toLowerCase()} For Reading, ${readingDesc.toLowerCase()} In Speaking, ${speakingDesc.toLowerCase()}`;
  }

  function printDiv(divId) {
    window.print();
  }

  /**
   * Which consolidated report the invitation gets. The TOEIC and IELTS reports
   * read different definition categories and score them on different scales,
   * so only the one matching the invitation's own test can produce a
   * meaningful report - the other would come out empty. Anything that is not
   * IELTS keeps the TOEIC report, which is what every invitation showed before
   * the IELTS report existed. Same rule as the report tabs in
   * sensay-assessment-admin.
   */
  $: ieltsInvitation = isIeltsInvitation(invitationDetail);

  /**
   * The per-skill report the reader has drilled into from the aggregated IELTS
   * report, or null while the aggregated report itself is on screen. The
   * detailed reports are rendered here rather than navigated to so that
   * returning to the aggregated report does not mean reloading the invitation.
   */
  let openedReport = null;

  function openSkillReport(event) {
    openedReport = event.detail;
    window.scrollTo({ top: 0 });
  }

  function closeSkillReport() {
    openedReport = null;
    window.scrollTo({ top: 0 });
  }
</script>

<div class="container-fluid mb-4">
  {#if loadStatus === "LOADING"}
    <Loader />
  {:else if loadStatus === "ERROR"}
    {$_("ERROR_LOADING_REPORT")}
  {:else if loadStatus === "OK"}
    {#if openedReport}
      <!-- Drill-down from the aggregated IELTS report: the same per-skill
           report the candidate reaches from the certificate link, with a way
           back to the aggregated one. -->
      <div class="report-back-bar">
        <button class="btn btn-outline-primary" on:click={closeSkillReport}>
          &larr;
          {$_("BACK_TO_OVERALL_REPORT")}
        </button>
      </div>
      {#key openedReport.instanceId}
        <AssessmentResults instanceId={openedReport.instanceId} />
      {/key}
    {:else if ieltsInvitation}
      {#if assessmentDefinitionDetailStatus === "LOADING" || invitationDetailStatus === "LOADING"}
        <Loader />
      {:else if assessmentDefinitionDetailStatus === "ERROR" || invitationDetailStatus === "ERROR"}
        {$_("ERROR_LOADING_REPORT")}
      {:else}
        <ResultReportIeltsOverall
          {invitationDetail}
          {assessmentDefinitionDetail}
          on:openReport={openSkillReport}
        />
      {/if}
    {:else}
    <div class="card shadow">
      <div class="container mt-5 mb-5" id="consolidate-report">
        <!-- Title -->
        <div class="row mb-4">
          <div class="col">
            <h1>TOEIC Consolidated Report</h1>
          </div>
        </div>

        {#if invitationDetailStatus === "LOADING"}
          <Loader />
        {:else if invitationDetailStatus === "ERROR"}
          {$_("ERROR_LOADING_REPORT")}
        {:else if assessmentDefinitionDetailStatus === "OK"}
          <!-- Student & Assessment Info -->
          <div class="row">
            <div class="col-md-9">
              <h4>Student Details</h4>
              <p>
                <strong>Invitation Number:</strong>
                {invitationDetail?.invitationNumber}
              </p>

              <p>
                <strong>Respondent Name:</strong>
                {invitationDetail?.clientName}
              </p>
              <p>
                <strong>Respondent Email:</strong>
                {invitationDetail?.clientId}
              </p>

              <p>
                <strong>Created At:</strong>
                {formatDateToLocale(invitationDetail?.createdAt)}
              </p>
              <p>
                <strong>Finished At:</strong>
                {formatDateToLocale(invitationDetail?.finishedAt)}
              </p>
            </div>
            <div class="col-md-3 text-md-right" id="no-print">
              <button
                on:click={() => printDiv("consolidate-report")}
                class="btn btn-primary mt-4 mt-md-0"
                target="_blank">{$_("EXPORT")}</button
              >
            </div>
          </div>

          <!-- Radar Chart & Comparison Table -->
          <div class="row align-items-center mt-4">
            <div class="col-md-6">
              <h2 class="mb-3">Overall Score</h2>
              <div class="radar-chart-container">
                <RadarChart chartDataInput={chartData} />
              </div>
            </div>
            <div class="col-md-6">
              <div class="card text-center">
                <div class="card-body">
                  <div class="score-value" style="font-size: 3rem;">
                    {scoreDetails("TOEIC_OVERALL", overallScore)?.score} / {scoreDetails(
                      "TOEIC_OVERALL",
                      overallScore,
                    )?.max}
                  </div>
                  <p class="text-muted mb-1">
                    Level: {scoreDetails("TOEIC_OVERALL", overallScore)?.level}
                  </p>

                  <!-- Progress bar with min/max indicators -->
                  <div
                    class="d-flex align-items-center justify-content-center my-3"
                  >
                    <span
                      >{scoreDetails("TOEIC_OVERALL", overallScore)?.min}</span
                    >
                    <div class="progress mx-2" style="width: 60%;">
                      <!-- Adjust the width of the bar based on the percentage (395/500 = 79%) -->
                      <div
                        class="progress-bar progress-bar-{scoreDetails(
                          'TOEIC_OVERALL',
                          overallScore,
                        )?.band}"
                        role="progressbar"
                        style="width: {scoreDetails(
                          'TOEIC_OVERALL',
                          overallScore,
                        )?.pct}%;"
                        aria-valuenow={scoreDetails(
                          "TOEIC_OVERALL",
                          overallScore,
                        )?.pct}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <span
                      >{scoreDetails("TOEIC_OVERALL", overallScore)?.max}</span
                    >
                  </div>

                  <!-- Color key (optional) -->
                  <small class="color-key text-muted">
                    <span style="color:#dc3545;"
                      >{scoreDetails("TOEIC_OVERALL", overallScore)
                        ?.min}-{scoreDetails("TOEIC_OVERALL", overallScore)
                        ?.mid}</span
                    >
                    <span style="color:#ffc107;"
                      >{scoreDetails("TOEIC_OVERALL", overallScore)
                        ?.mid}-{scoreDetails("TOEIC_OVERALL", overallScore)
                        ?.high}</span
                    >
                    <span style="color:#28a745;"
                      >{scoreDetails("TOEIC_OVERALL", overallScore)
                        ?.high}-{scoreDetails("TOEIC_OVERALL", overallScore)
                        ?.max}</span
                    >
                  </small>
                </div>
                <div class="card-footer" style="text-align: justify;">
                  <p>{generateTOEICDescription(chartData)}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="row g-4 mt-4">
            <!-- Reading Score Card -->

            {#each assessmentDefinitionDetail.filter((e) => e.invDefStatus !== "CANCEL") as l, i}
              <div class="col-md-4">
                <div class="card text-center">
                  <div class="card-header">
                    <span class="score-title"
                      >{l.name}</span
                    >
                  </div>
                  <div class="card-body">
                    <div class="score-value">
                      {#if l?.idInstance}
                        {scoreDetails(l.category, l.reviewScore)
                          ?.score}{:else}-{/if} / {scoreDetails(
                        l.category,
                        l.reviewScore,
                      )?.max}
                    </div>
                    <p class="text-muted mb-1">
                      Level: {scoreDetails(l.category, l.reviewScore)?.level}
                    </p>

                    <!-- Progress bar with min/max indicators -->
                    <div
                      class="d-flex align-items-center justify-content-center my-3"
                    >
                      <span>{scoreDetails(l.category, l.reviewScore)?.min}</span
                      >
                      <div class="progress mx-2" style="width: 60%;">
                        <!-- Adjust the width of the bar based on the percentage (395/500 = 79%) -->
                        <div
                          class="progress-bar progress-bar-{scoreDetails(
                            l.category,
                            l.reviewScore,
                          )?.band}"
                          role="progressbar"
                          style="width: {scoreDetails(l.category, l.reviewScore)
                            ?.pct}%;"
                          aria-valuenow={scoreDetails(l.category, l.reviewScore)
                            ?.pct}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                      <span>{scoreDetails(l.category, l.reviewScore)?.max}</span
                      >
                    </div>

                    <!-- Color key (optional) -->
                    <small class="color-key text-muted">
                      <span style="color:#dc3545;"
                        >{scoreDetails(l.category, overallScore)
                          ?.min}-{scoreDetails(l.category, l.reviewScore)
                          ?.mid}</span
                      >
                      <span style="color:#ffc107;"
                        >{scoreDetails(l.category, l.reviewScore)
                          ?.mid}-{scoreDetails(l.category, l.reviewScore)
                          ?.high}</span
                      >
                      <span style="color:#28a745;"
                        >{scoreDetails(l.category, l.reviewScore)
                          ?.high}-{scoreDetails(l.category, l.reviewScore)
                          ?.max}</span
                      >
                    </small>
                  </div>
                </div>
              </div>
            {/each}
          </div>
        {/if}

        <div class="row mt-4">
          <div class="col comparison-table">
            <h3>
              Comparison Table - {readListenScore} - {scoreDetails(
                "TOEIC_READ_LISTEN",
                readListenScore,
              )?.level}
            </h3>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Level</th>
                  <th>CEFR</th>
                  <th>TOEIC Listening+Reading</th>
                  <th>TOEIC Listening Range</th>
                  <th>TOEIC Reading Range</th>
                  <th>TOEIC Speaking Range</th>
                  <th style="min-width: 5em;">TOEFL</th>
                  <th style="min-width: 6em;">IELTS</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class:table-primary={scoreDetails(
                    "TOEIC_OVERALL",
                    overallScore,
                  )?.level === "Beginner"}
                >
                  <th>Beginner</th>
                  <td>A1</td>
                  <td
                    class:table-success={scoreDetails(
                      "TOEIC_READ_LISTEN",
                      readListenScore,
                    )?.level === "Beginner"}>120-215</td
                  >
                  <td>60-105</td>
                  <td>60-110</td>
                  <td>50-80</td>
                  <td>0-18</td>
                  <td>1.5</td>
                </tr>
                <tr
                  class:table-primary={scoreDetails(
                    "TOEIC_OVERALL",
                    overallScore,
                  )?.level === "High Beginner"}
                >
                  <th>High Beginner</th>
                  <td>A2</td>
                  <td
                    class:table-success={scoreDetails(
                      "TOEIC_READ_LISTEN",
                      readListenScore,
                    )?.level === "High Beginner"}>220-545</td
                  >
                  <td>110-270</td>
                  <td>115-270</td>
                  <td>90-110</td>
                  <td>18-55</td>
                  <td>2.0-3.5</td>
                </tr>
                <tr
                  class:table-primary={scoreDetails(
                    "TOEIC_OVERALL",
                    overallScore,
                  )?.level === "Low Intermediate"}
                >
                  <th>Low Intermediate</th>
                  <td>B1</td>
                  <td
                    class:table-success={scoreDetails(
                      "TOEIC_READ_LISTEN",
                      readListenScore,
                    )?.level === "Low Intermediate"}>550-780</td
                  >
                  <td>275-395</td>
                  <td>275-380</td>
                  <td>120-150</td>
                  <td>56-81</td>
                  <td>4.0-5.0</td>
                </tr>
                <tr
                  class:table-primary={scoreDetails(
                    "TOEIC_OVERALL",
                    overallScore,
                  )?.level === "Intermediate"}
                >
                  <th>Intermediate</th>
                  <td>B2</td>
                  <td
                    class:table-success={scoreDetails(
                      "TOEIC_READ_LISTEN",
                      readListenScore,
                    )?.level === "Intermediate"}>785-940</td
                  >
                  <td>400-485</td>
                  <td>385-450</td>
                  <td>160-170</td>
                  <td>82-99</td>
                  <td>5.5-6.5</td>
                </tr>
                <tr
                  class:table-primary={scoreDetails(
                    "TOEIC_OVERALL",
                    overallScore,
                  )?.level === "High Intermediate"}
                >
                  <th>High Intermediate</th>
                  <td>C1</td>
                  <td
                    class:table-success={scoreDetails(
                      "TOEIC_READ_LISTEN",
                      readListenScore,
                    )?.level === "High Intermediate"}>945-990</td
                  >
                  <td>490-495</td>
                  <td>455-495</td>
                  <td>180-200</td>
                  <td>100-110</td>
                  <td>7.0-8.0</td>
                </tr>
                <tr
                  class:table-primary={scoreDetails(
                    "TOEIC_OVERALL",
                    overallScore,
                  )?.level === "Advanced"}
                >
                  <th>Advanced</th>
                  <td>C2</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>111-120</td>
                  <td>8.5-9.0</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    {/if}
  {/if}
</div>

<style>
  .card {
    min-height: 20em;
    background-color: white;
    text-align: left;
  }

  .card-header {
    color: #1e1e1e;
    font-family: "Noto Sans", serif;
    background-color: #e8f4f4;
    border-bottom: none;
    font-size: large;
    font-weight: 700;
  }

  .card-body {
    font-size: small;
    font-weight: 100;
    min-height: 20em;
  }

  .card-footer {
    background-color: #e8f4f4;
    border-top: none;
  }

  .btn-start {
    background-color: #00a094;
    color: #ffffff;
  }

  .card-footer {
    min-height: 4em;
  }

  /* Screen-only navigation back to the aggregated IELTS report; the printed
     detailed report is a document in its own right. */
  .report-back-bar {
    max-width: 1500px;
    margin: 1.5rem auto 0;
    padding: 0 2rem;
  }

  .score {
    font-weight: 600;
  }
  .definition {
    min-width: 12em;
    display: inline-block;
  }

  /* Example custom styles */
  .score-section {
    background-color: #f9f9f9;
    border-radius: 6px;
    padding: 20px;
    margin-bottom: 20px;
  }
  .score-section h3 {
    margin-top: 0;
  }
  .overall-score {
    background-color: #eef2f7;
    padding: 20px;
    border-radius: 6px;
    margin-bottom: 20px;
  }
  .comparison-table table {
    width: 100%;
  }
  /* Center the chart and give it a max width */
  .radar-chart-container {
    max-width: 500px;
    margin: 0 auto;
  }

  .score-title {
    font-size: 1.25rem;
    font-weight: 600;
  }
  .score-value {
    font-size: 2rem;
    font-weight: 700;
  }
  .color-key span:not(:last-child)::after {
    content: ",";
    margin-right: 0.3rem;
  }
  .progress {
    height: 8px;
  }
  /* Example color thresholds for demonstration */
  .progress-bar-red {
    background-color: #dc3545; /* red */
  }
  .progress-bar-amber {
    background-color: #ffc107; /* yellow */
  }
  .progress-bar-green {
    background-color: #28a745; /* green */
  }

  @media print {
    @page {
      size: A4;
      width: 1000px;
      margin: 0cm 0cm 0cm 0cm;
    }

    html,
    body {
      width: 100%;
      margin: 0 !important;
      padding: 0 !important;
    }

    .container,
    .container-fluid {
      width: 100% !important;
      max-width: none !important;
    }

    /* Optional: Make sure columns don't stack like mobile */
    .row {
      display: flex !important;
      flex-wrap: nowrap !important;
    }

    [class*="col-"] {
      flex: 1 !important;
      max-width: 100% !important;
    }

    #no-print,
    .report-back-bar {
      display: none;
    }

    /* All your print styles go here */
    .progress {
      position: relative;
    }
    .progress:before {
      display: block;
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 0;
      border-bottom: 2rem solid #eeeeee;
    }
    .progress-bar {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      z-index: 1;
      border-bottom: 2rem solid #337ab7;
    }
    .progress-bar-success {
      border-bottom-color: #67c600;
    }
    .progress-bar-info {
      border-bottom-color: #5bc0de;
    }
    .progress-bar-warning {
      border-bottom-color: #f0a839;
    }
    .progress-bar-danger {
      border-bottom-color: #ee2f31;
    }

    .progress-bar-red {
      border-bottom-color: #dc3545; /* red */
    }
    .progress-bar-amber {
      border-bottom-color: #ffc107; /* yellow */
    }
    .progress-bar-green {
      border-bottom-color: #28a745; /* green */
    }

    .status-icon {
      color: black;
      font-weight: 500;
    }
  }

  .status-icon {
    width: 1.5em;
    height: 1.5em;
    border-radius: 0.5em;
    align-items: center;
    justify-content: center;
    color: white;
    font-family: Arial, sans-serif;
    font-weight: bold;
    font-size: 0.8em;
    padding: 0.5em;
  }

  .new {
    background-color: #2196f3; /* Vibrant blue */
  }

  .in-progress {
    background-color: #e93bde; /* Vibrant blue */
  }

  .scored {
    background-color: #4caf50; /* Fresh green */
  }

  .reviewed {
    background-color: #9c27b0; /* Royal purple */
  }

  .warning {
    background-color: #ec2626; /* Vibrant blue */
  }
</style>
